import React from 'react';

const Body = () => (
    <>
        <h2>Our People</h2>
        <br />
        The talented individuals working with the Group are integral to our continued success, delivering exceptional
        results year after year. We aim to attract, retain and develop the best talent at every level throughout the
        Group and believe that an engaged workforce is vital to achieving our aims. We strive to create a workplace in
        which everyone is safe; supported and respected; treated fairly and taken care of; listened to; and motivated to
        achieve their full potential. We are committed to achieving excellence in the areas of health and safety and the
        protection of our colleagues in their working environment.
        <h2>2020 – Promoting Inclusivity</h2>
        <br />
        <video
            type="video/mp4"
            src="https://files.jdplc.com/images/about/our-people.mp4"
            controls="true"
            style={{ width: '100%' }}
            poster="https://files.jdplc.com/images/about/our-people-video-thumbnail.png"
        ></video>
        <br />
        <br />
        The Group is absolutely committed to promoting policies which ensure that colleagues and customers are treated
        equally regardless of ethnicity, social origin, gender, sexual orientation, disability or age. Following the
        tragic death of George Floyd in the United States, we worked with our teams around the world and with both the
        JD Foundation and the Finish Line Youth Foundation to ensure that, across the Group, we play an integral part in
        what is hopefully a united global approach to eradicate not just racism but all forms of discrimination from
        society.
        <br />
        <br />
        We have now launched our Inclusivity Campaign which will support our promise to education and train our
        colleagues, with a focus on key topics such as Equality, Diversity, Biases and Cultural Intelligence. Alongside
        the introduction of our Diversity &amp; Inclusion forums for our colleagues, we are committed to engage, learn
        and promote dialogue around potentially sensitive subjects in order to improve understanding and awareness
        throughout the business.
        <br />
        <br />
        In addition, a series of videos have been created highlighting individual experiences of diversity and
        inclusivity and is distributed via JD4U (our people platform) to emphasise the importance of the campaign to all
        colleagues and drive engagement at all levels.
    </>
);

export const content = {
    body: Body,
};
